var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import MuiContainer from "@material-ui/core/Container";
import { makeStyles, createStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        root: (_a = {
                position: "relative",
                maxWidth: function (props) { return (props._maxWidth !== undefined ? props._maxWidth : undefined); },
                padding: function (props) { return "0 " + (props.padding !== undefined ? props.padding : "72px"); }
            },
            _a[theme.breakpoints.down("md")] = {
                padding: function (props) { return (props.fullWidthMobile ? 0 : "0 16px"); },
            },
            _a),
    });
});
var Container = function (props) {
    var fullWidthMobile = props.fullWidthMobile, padding = props.padding, _maxWidth = props._maxWidth, containerProps = __rest(props, ["fullWidthMobile", "padding", "_maxWidth"]);
    var styles = useStyles({ fullWidthMobile: fullWidthMobile, padding: padding, _maxWidth: _maxWidth });
    return (React.createElement(MuiContainer, __assign({ classes: { root: styles.root } }, containerProps), props.children));
};
Container.displayName = "Container";
Container.defaultProps = {
    fullWidthMobile: false,
};
export default Container;
